import { Hero } from "./Hero";

/**
 * Centered logged out view with just the Hero (no typewriter animation).
 * Used on `/images` and `/settings` when the user is not authenticated.
 */
export function LoggedOutView() {
  return (
    <div className="flex w-full items-center justify-center h-full">
      <Hero showBrandDescription={true} showBrandHeader={false} skipAnimation />
    </div>
  );
}
